<!-- Zweck: Stellt die HTML-Struktur für app reset password component im Frontend bereit. -->
<div class="logincontentinner">
  <div>
    <div class="loginlogobox">
      <img class="logo" src="{{domaincfg.logofilename}}"/>
    </div>


    <div class="loginbox">
      <div class="bar">Passwort Rücksetzung</div>


      @if (!token) {
        <div>
          @if (!(message|async)) {
            <div>
              <p>Bitte geben Sie Ihre E-Mail Adresse ein</p>
              <mat-form-field appearance="outline">
                <mat-label>E-Mail</mat-label>
                <input matInput [(ngModel)]="email" email required #emailform="ngModel" (keydown.enter)="send1()">
                @if (!emailform.valid) {
                  <mat-error>Ungültige E-Mail Adresse!</mat-error>
                }
              </mat-form-field>
              <div style="height: 50px; font-size: 16px; color: red">
                {{error|async}}
              </div>
              <div class="form-group">
                <button [disabled]="(loading|async) || !emailform.valid || email == '' || send" class="btn btn-primary" mat-flat-button (click)="send1()">
                  <svg-icon>senden</svg-icon>
                  Weiter
                </button>
                @if (loading|async) {
                  <div>
                    <img
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
            </div>
}
          </div>
        </div>
}

        @if (message|async) {
<div>
          <h3>{{message|async}}</h3>

          <button [disabled]="loading|async" class="btn btn-primary" mat-flat-button routerLink="/login">
            <svg-icon>weiter</svg-icon>
            OK
          </button>
        </div>
}
      </div>
}

      @if (token && frmgrp2) {
<div>
        <form [formGroup]="frmgrp2">
          @if (!(message|async)) {
<div>
            <p>Bitte geben Sie Ihr neues Passwort ein</p>
            <mat-form-field style="width: 300px">
              <mat-label>Passwort</mat-label>
              <input matInput formControlName="password" type="password" (keydown.enter)="send2()">
            </mat-form-field>

            <div style="text-align: left">
              <label
                class="col"
                      [ngClass]="frmgrp2.controls['password'].hasError('required') || frmgrp2.controls['password'].hasError('minlength') || frmgrp2.controls['password'].hasError('maxlength')  ? 'text-danger' : 'text-success'"
                      >
                      <i class="material-icons">
                        {{ frmgrp2.controls['password'].hasError('required') ||
                        frmgrp2.controls['password'].hasError('minlength') ? 'cancel' :
                        'check_circle' }}
                      </i>
                      <div style="height: 24px; display: inline-block; vertical-align: top">
                        Zwischen 8 und 30 Zeichen!
                      </div>
                    </label>
                    <br>
                      <label
                        class="col"
                        [ngClass]="frmgrp2.controls['password'].hasError('required') || frmgrp2.controls['password'].hasError('hasNumber')  ? 'text-danger' : 'text-success'"
                        >
                        <i class="material-icons">
                          {{ frmgrp2.controls['password'].hasError('required') ||
                          frmgrp2.controls['password'].hasError('hasNumber') ? 'cancel' :
                          'check_circle' }}
                        </i>
                        <div style="height: 24px; display: inline-block; vertical-align: top">
                          Mindestens 1 Nummer!
                        </div>
                      </label>
                      <br>
                        <label
                          class="col"
                          [ngClass]="frmgrp2.controls['password'].hasError('required') || frmgrp2.controls['password'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'"
                          >
                          <i class="material-icons">
                            {{ frmgrp2.controls['password'].hasError('required') ||
                            frmgrp2.controls['password'].hasError('hasCapitalCase') ? 'cancel' :
                            'check_circle' }}
                          </i>
                          <div style="height: 24px; display: inline-block; vertical-align: top">
                            Mindestens 1 Großbuchstaben!
                          </div>
                        </label>
                        <br>
                          <label
                            class="col"
                            [ngClass]="frmgrp2.controls['password'].hasError('required') || frmgrp2.controls['password'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'"
                            >
                            <i class="material-icons">
                              {{ frmgrp2.controls['password'].hasError('required') ||
                              frmgrp2.controls['password'].hasError('hasSmallCase') ? 'cancel' :
                              'check_circle' }}
                            </i>
                            <div style="height: 24px; display: inline-block; vertical-align: top">
                              Mindestens 1 Kleinbuchstaben!
                            </div>
                          </label>
                          <br>
                            <label
                              class="col"
                              [ngClass]="frmgrp2.controls['password'].hasError('required') || frmgrp2.controls['password'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'"
                              >
                              <i class="material-icons">
                                {{ frmgrp2.controls['password'].hasError('required') ||
                                frmgrp2.controls['password'].hasError('hasSpecialCharacters') ? 'cancel' :
                                'check_circle' }}
                              </i>
                              <div style="height: 24px; display: inline-block; vertical-align: top">
                                Mindestens 1 Sonderzeichen!
                              </div>
                            </label>
                          </div>
                          <br>
                            <mat-form-field style="width: 300px">
                              <mat-label>Passwort wiederholen</mat-label>
                              <input matInput formControlName="confirmPassword" type="password" (keydown.enter)="send2()">
                            </mat-form-field>
                            @if (!frmgrp2.controls['password'].hasError('required')) {
                              <div style="width: 280px; text-align: left">
                                <label
                                  class="col"
                                  [ngClass]="frmgrp2.controls['confirmPassword'].hasError('NoPasswordMatch') ? 'text-danger' : 'text-success'"
                                  >
                                  <i class="material-icons">
                                    {{ frmgrp2.controls['confirmPassword'].hasError('NoPasswordMatch') ? 'cancel' :
                                    'check_circle' }}
                                  </i>
                                  @if (frmgrp2.controls['confirmPassword'].hasError('NoPasswordMatch')) {
                                    <div style="height: 24px; display: inline-block; vertical-align: top">
                                      Passwörter stimmen nicht überein!
                                    </div>
                                  }
                                </label>
                              </div>
                            }
                            <div style="height: 50px; font-size: 16px; color: red">
                              {{error|async}}
                            </div>
                            <div class="form-group">
                              <button [disabled]="(loading|async) || !frmgrp2.controls['password'].valid || !frmgrp2.controls['confirmPassword'].valid || send" class="btn btn-primary" mat-flat-button (click)="send2()">
                                <svg-icon>senden</svg-icon>
                                Weiter
                              </button>
                              @if (loading|async) {
                                <div>
                                  <img
                  src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
              </div>
}
            </div>
          </div>
}
        </form>

        @if (message|async) {
<div>
          <h3>{{message|async}}</h3>

          <button [disabled]="loading|async" class="btn btn-primary" mat-flat-button routerLink="/login">
            <svg-icon>login</svg-icon>
            Anmelden
          </button>
        </div>
}
      </div>
}
      <br>

      <button [disabled]="loading|async" class="btn btn-primary" mat-flat-button routerLink="/login">
        <svg-icon>zurueck</svg-icon>
        Abbrechen
      </button>
    </div>
  </div>
</div>
